import { useEffect, useMemo, useState } from 'react';
import {
  getAllSubjectDifficulties,
  updateSubjectDifficulty,
} from 'services/api/subject-difficulties';
import { EducationLevel } from 'services/api/types';
import type { SubjectWithDifficulty } from 'services/api/subject-difficulties';
import { getColumns } from '../components/Table/config';

export const useSubjectDifficulties = () => {
  const [loading, setLoading] = useState(false);
  const [subjects, setSubjects] = useState<SubjectWithDifficulty[]>([]);
  const [selectedTab, setSelectedTab] = useState<EducationLevel>(EducationLevel.Noo);

  const getSubjectDifficultiesData = () => {
    setLoading(true);
    getAllSubjectDifficulties()
      .then((res) => {
        setSubjects(res);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const selectedSubjectsByTab = useMemo(() => {
    return subjects.filter((subject) => subject.subjectEducationLevel === selectedTab);
  }, [subjects, selectedTab]);

  const handleSelectTab = (key: string) => {
    setSelectedTab(key as EducationLevel);
  };

  const handleDifficultyChange = (subjectId: number, field: string, value: number) => {
    updateSubjectDifficulty(subjectId, { [field]: value }).then(() => {
      getSubjectDifficultiesData();
    });
  };

  const columns = useMemo(() => getColumns(handleDifficultyChange, selectedTab), [selectedTab]);

  useEffect(() => {
    getSubjectDifficultiesData();
  }, []);

  return {
    state: { subjects: selectedSubjectsByTab, loading, selectedTab, columns },
    methods: { handleSelectTab },
  };
};
